import { render, staticRenderFns } from "./RestPwdDialog.vue?vue&type=template&id=891a567c&lang=pug&"
import script from "./RestPwdDialog.vue?vue&type=script&lang=ts&"
export * from "./RestPwdDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports